module.exports = __webpack_public_path__ + "img/data1-4.66589351.png";